// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const doctor = {
//   id: 8,
//   name: 'Dr. Saroj Rustgi',
//   qual: 'BPTH/BPT, MPTh/MPT, Diploma in Natural Health & Yoga',
//   specialty: 'Physiotherapist',
//   initials: 'SR',
//   color: '#185FA5',
//   verified: true,
//   image: '/images/doctor1.png',
//   clinic: 'Wellness First Physiotherapy+',
//   location: 'B-279, Near Hong Kong Bazar, Sushant Lok III, Sector 57, Gurgaon',
//   city: 'Gurgaon',
//   fee: 1000,
//   phone: '7838455530',
//   website: 'https://wellnessfirstphysio.in',
//   googleMaps: 'https://share.google/JP9YIwIlxBrnnpx7i',
//   practo: 'https://www.practo.com/gurgaon/doctor/dr-saroj-rustgi-rehab-physical-medicine-specialist',
//   hours: 'Mon–Sat: 8:30 AM–2:00 PM & 4:30 PM–7:30 PM | Sun: 9:00 AM–12:30 PM',
//   about: 'Dr. Saroj Rustgi (PT) is a renowned physiotherapist with 46 years of experience — 39 years as Head of Physiotherapy Department at Northern Railway Central Hospital, followed by over 10 years running Wellness First Physiotherapy+ in Sushant Lok 3, Sector 57, Gurugram. She specialises in clinical diagnosis, therapeutics, musculoskeletal and sports physiotherapy, and neurological rehabilitation. She also practises advanced techniques including Dry Needling, Cupping, and IASTM. Video consultation is available through her clinic.',
//   services: [
//     'Exercise Therapy', 'Balance & Coordination Training', 'Gait Training',
//     'TENS', 'IFT', 'Muscle Stimulation', 'Short Wave Diathermy', 'LASER Therapy',
//     'Manual Therapy', 'Trigger Point Therapy', 'Joint Mobilization', 'Myofascial Release',
//     'Stroke Rehabilitation', 'Knee Replacement Rehab', 'Hip Replacement Rehab',
//     'Back Pain Treatment', 'Neck Pain Treatment', 'Home Physiotherapy Services',
//     'Dry Needling', 'Cupping Therapy', 'IASTM', 'Cryotherapy / Cold Therapy',
//     'Heat Therapy', 'Electrical Stimulation',
//   ],
//   specializations: [
//     'Sports & Musculoskeletal Physiotherapist',
//     'Orthopaedic Physiotherapist',
//     'Neurological Rehabilitation',
//     'Cardiovascular & Pulmonary Physiotherapy',
//   ],
//   education: [
//     { degree: 'BPTH/BPT', institute: 'Pt. Deen Dayal Upadhyaya Institute for the Physically Handicapped, New Delhi', year: '1975' },
//     { degree: 'MPTh/MPT — Orthopaedic Physiotherapy', institute: 'Singhania University, Jhunjhunu', year: '2010' },
//     { degree: 'Diploma in Natural Health & Yoga', institute: 'International Foundation of Natural Health and Yoga', year: '1992' },
//   ],
//   memberships: ['Indian Association of Physiotherapists'],
//   awards: [
//     'Guest of Honour — ITS College of Physiotherapy, Meerut',
//     'Certificate of Merit — Northern Railway',
//     'Head of Physiotherapy Department — Northern Railway Central Hospital (39 years)',
//   ],
// };

// // ── Star Rating Component ─────────────────────────────────────────────────────
// const StarRating = ({ value, onChange, readonly = false }) => (
//   <div style={{ display: 'flex', gap: 4 }}>
//     {[1, 2, 3, 4, 5].map(star => (
//       <button key={star} onClick={() => !readonly && onChange(star)}
//         style={{ background: 'none', border: 'none', cursor: readonly ? 'default' : 'pointer', padding: 0, fontSize: 22, color: star <= value ? '#39a5d3' : '#d1d5db', lineHeight: 1 }}>
//         ★
//       </button>
//     ))}
//   </div>
// );

// // ── Slot Picker — Simple like Practo ─────────────────────────────────────────
// const morningSlots = ['8:30 AM','9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM'];
// const afternoonSlots = ['12:00 PM','12:30 PM','1:00 PM','1:30 PM'];
// const eveningSlots = ['4:30 PM','5:00 PM','5:30 PM','6:00 PM','6:30 PM','7:00 PM','7:30 PM'];
// const sundaySlots  = ['9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','12:30 PM'];

// const SlotPicker = ({ doctor }) => {
//   const [selected, setSelected] = useState(null);

//   const SlotBtn = ({ time }) => (
//     <button onClick={() => setSelected(time)}
//       style={{
//         padding: '6px 0', fontSize: 12, borderRadius: 3, cursor: 'pointer',
//         border: selected === time ? '1.5px solid #39a5d3' : '1px solid #d0e0ea',
//         background: selected === time ? '#e8f4fb' : '#fff',
//         color: selected === time ? '#39a5d3' : '#444',
//         fontWeight: selected === time ? 700 : 400,
//         fontFamily: 'inherit', transition: 'all 0.1s',
//         width: '31%',
//       }}>
//       {time}
//     </button>
//   );

//   const allMonSatSlots = [...morningSlots, ...afternoonSlots, ...eveningSlots];

//   const handleBook = () => {
//     const params = new URLSearchParams({
//       doctor: doctor.name,
//       clinic: doctor.clinic,
//       slot: selected,
//       phone: doctor.phone,
//     });
//     window.location.href = `/book-appointment?${params.toString()}`;
//   };

//   return (
//     <div style={{ padding: '14px 18px' }}>
//       <div style={{ fontSize: 11, fontWeight: 700, color: '#19354a', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Mon – Sat</div>
//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
//         {allMonSatSlots.map(t => <SlotBtn key={t} time={t} />)}
//       </div>
//       <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 12, marginBottom: 8 }}>
//         <div style={{ fontSize: 11, fontWeight: 700, color: '#19354a', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Sunday</div>
//         <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
//           {sundaySlots.map(t => <SlotBtn key={t} time={t} />)}
//         </div>
//       </div>
//       {selected && (
//         <div style={{ padding: '8px 12px', background: '#f0f7fb', borderRadius: 3, fontSize: 12, color: '#19354a', marginBottom: 10 }}>
//           Selected: <strong>{selected}</strong>
//         </div>
//       )}
//       <button onClick={handleBook} disabled={!selected}
//         style={{
//           width: '100%', padding: '11px 0', fontSize: 13, fontWeight: 700,
//           background: selected ? '#39a5d3' : '#e8e8e8',
//           color: selected ? '#fff' : '#aaa',
//           border: 'none', borderRadius: 3,
//           cursor: selected ? 'pointer' : 'not-allowed',
//           fontFamily: 'inherit',
//         }}>
//         {selected ? 'Book Appointment' : 'Select a Time Slot'}
//       </button>
//     </div>
//   );
// };

// // ── Main Component ─────────────────────────────────────────────────────────────
// const DrSarojRustgi = () => {
//   const [activeTab, setActiveTab] = useState('info');
//   const [reviews, setReviews] = useState([
//     {
//       id: 1,
//       name: 'Nitin Saraswat',
//       verified: true,
//       visitedFor: 'Neurological Rehabilitation',
//       rating: 5,
//       date: '10 years ago',
//       text: 'We were actively looking out for a good physiotherapist for my father who suffered a stroke 3 years back. We tried services like Portea and found that their physios did not have an empathetic attitude towards the patient. Ms. Saroj and Mr. Ishwar have done a great job in striking a bonding with my father and providing a more holistic and empathetic physio treatment. Their services are both economical and effective and its been more than 4 months and I am a regular visitor there.',
//     },
//     {
//       id: 2,
//       name: 'Anusha Bode',
//       verified: true,
//       visitedFor: 'Back Pain',
//       rating: 5,
//       date: '2 years ago',
//       text: 'It was a great experience with Dr. Saroj Ji. My husband went to consult about my lower back pain which was an ongoing issue from last few years. We consulted other physiotherapists in the past and they simply treated it with wave therapy. What really sets Dr. Saroj apart is the explanation behind what is done. She explained why lower back pain happens, the causes in detail, and helped me realise that bad posture is the biggest culprit. With every session, she suggested how to include good posture habits in our daily routine and some light exercises to strengthen the core. I liked that she treated the issue not just professionally but gave personal tips for long term recovery. I would strongly recommend her.',
//     },
//     {
//       id: 3,
//       name: 'Manoj Kumar',
//       verified: true,
//       visitedFor: 'Shoulder Pain',
//       rating: 5,
//       date: '3 years ago',
//       text: 'I had pain in my shoulder since last three months. I consulted Dr. Saroj for this and she prescribed physiotherapy sessions at her clinic for 10 days. I underwent these sessions and also did multiple physical exercises advised by the doctor on daily basis. The doctor closely watched me performing the exercises and corrected me where required. After 10 sessions I have fully recovered from my pain. I strongly recommend Dr. Saroj for her expertise and thorough knowledge.',
//     },
//   ]);
//   const [showForm, setShowForm] = useState(false);
//   const [newReview, setNewReview] = useState({ name: '', rating: 0, text: '' });
//   const [submitted, setSubmitted] = useState(false);

//   const handleSubmitReview = (e) => {
//     e.preventDefault();
//     if (!newReview.name || !newReview.rating || !newReview.text) return;
//     setReviews(prev => [{
//       id: Date.now(),
//       name: newReview.name,
//       rating: newReview.rating,
//       date: 'Just now',
//       text: newReview.text,
//     }, ...prev]);
//     setNewReview({ name: '', rating: 0, text: '' });
//     setSubmitted(true);
//     setTimeout(() => { setSubmitted(false); setShowForm(false); }, 2000);
//   };

//   const avgRating = reviews.length
//     ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1)
//     : null;

//   const tabs = ['info', 'services', 'stories'];

//   return (
//     <div style={{ minHeight: '100vh', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif" }}>

//       {/* Breadcrumb */}
//       <div style={{ background: '#fff', borderBottom: '1px solid #eaecef', padding: '10px 0' }}>
//         <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', fontSize: 12, color: '#888', display: 'flex', gap: 6, alignItems: 'center' }}>
//           <Link to="/" style={{ color: '#888', textDecoration: 'none' }}>Home</Link>
//           <span>›</span>
//           <Link to="/doctors" style={{ color: '#888', textDecoration: 'none' }}>Find Doctors</Link>
//           <span>›</span>
//           <Link to="/doctors?city=Gurgaon" style={{ color: '#888', textDecoration: 'none' }}>Gurgaon</Link>
//           <span>›</span>
//           <Link to="/doctors?specialty=Physiotherapist" style={{ color: '#888', textDecoration: 'none' }}>Physiotherapist</Link>
//           <span>›</span>
//           <span style={{ color: '#333' }}>Dr. Saroj Rustgi</span>
//         </div>
//       </div>

//       <div style={{ maxWidth: 1100, margin: '24px auto', padding: '0 24px', display: 'grid', gridTemplateColumns: '1fr 340px', gap: 24, alignItems: 'start' }}>

//         {/* ── LEFT ── */}
//         <div>

//           {/* Doctor Header Card */}
//           <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: '28px 28px 0', marginBottom: 0 }}>
//             {/* Top section */}
//             <div style={{ display: 'flex', gap: 22, paddingBottom: 22, borderBottom: '1px solid #eaecef' }}>
//               {/* Doctor Image */}
//               <div style={{ width: 88, height: 88, borderRadius: 4, overflow: 'hidden', flexShrink: 0, border: '1px solid #eaecef' }}>
//                 <img src={doctor.image} alt={doctor.name}
//                   style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                   onError={e => {
//                     e.target.style.display = 'none';
//                     e.target.parentNode.style.background = '#e8f0fb';
//                     e.target.parentNode.style.display = 'flex';
//                     e.target.parentNode.style.alignItems = 'center';
//                     e.target.parentNode.style.justifyContent = 'center';
//                     e.target.parentNode.innerHTML = `<span style="font-size:26px;font-weight:700;color:#185FA5">${doctor.initials}</span>`;
//                   }}
//                 />
//               </div>
//               <div style={{ flex: 1 }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 3 }}>
//                   <h1 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', margin: 0 }}>{doctor.name}</h1>
//                   {doctor.verified && (
//                     <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#2e7d32', fontWeight: 600 }}>
//                       <svg width="14" height="14" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
//                       Medical Registration Verified
//                     </span>
//                   )}
//                 </div>
//                 <p style={{ fontSize: 14, color: '#555', margin: '0 0 3px' }}>{doctor.qual}</p>
//                 <p style={{ fontSize: 14, color: '#39a5d3', fontWeight: 600, margin: '0 0 6px' }}>{doctor.specialty}</p>
//                 <p style={{ fontSize: 13, color: '#666', margin: '0 0 10px' }}>40+ Years Experience Overall</p>

//                 {/* Rating summary — only show if reviews exist */}
//                 {avgRating && (
//                   <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#39a5d3', color: '#fff', fontSize: 13, fontWeight: 700, padding: '3px 10px', borderRadius: 6 }}>
//                       ★ {avgRating}
//                     </div>
//                     <span style={{ fontSize: 13, color: '#555' }}>{reviews.length} Patient Reviews</span>
//                     <button onClick={() => setActiveTab('stories')}
//                       style={{ fontSize: 12, color: '#39a5d3', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0 }}>
//                       See all reviews
//                     </button>
//                   </div>
//                 )}
//                 {!avgRating && (
//                   <button onClick={() => setActiveTab('stories')}
//                     style={{ fontSize: 13, color: '#39a5d3', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontFamily: 'inherit' }}>
//                     Be the first to write a review
//                   </button>
//                 )}
//               </div>
//             </div>

//             {/* Tabs */}
//             <div style={{ display: 'flex', gap: 0 }}>
//               {tabs.map(tab => (
//                 <button key={tab} onClick={() => setActiveTab(tab)}
//                   style={{
//                     padding: '14px 24px', fontSize: 14, fontWeight: activeTab === tab ? 700 : 400,
//                     color: activeTab === tab ? '#39a5d3' : '#888',
//                     background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit',
//                     borderBottom: activeTab === tab ? '2.5px solid #39a5d3' : '2.5px solid transparent',
//                     transition: 'all 0.15s',
//                     textTransform: 'capitalize',
//                   }}>
//                   {tab === 'stories' ? `Stories (${reviews.length})` : tab.charAt(0).toUpperCase() + tab.slice(1)}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* ── INFO TAB ── */}
//           {activeTab === 'info' && (
//             <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>

//               {/* About */}
//               <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                 <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 12, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>About</h2>
//                 <p style={{ fontSize: 14, color: '#555', lineHeight: 1.75, margin: 0 }}>{doctor.about}</p>
//               </div>

//               {/* Specializations + Education side by side */}
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
//                 <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                   <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Specializations</h2>
//                   {doctor.specializations.map(s => (
//                     <div key={s} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', marginBottom: 10 }}>
//                       <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 5 }} />
//                       {s}
//                     </div>
//                   ))}
//                 </div>
//                 <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                   <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Education</h2>
//                   {doctor.education.map((e, i) => (
//                     <div key={i} style={{ marginBottom: 12 }}>
//                       <div style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{e.degree}</div>
//                       {e.institute && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{e.institute}{e.year ? `, ${e.year}` : ''}</div>}
//                       {e.note && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{e.note}</div>}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Awards */}
//               {doctor.awards.length > 0 && (
//                 <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                   <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Awards & Recognition</h2>
//                   {doctor.awards.map(a => (
//                     <div key={a} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, color: '#444' }}>
//                       <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 5, display: 'inline-block' }} />
//                       {a}
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Clinic Info */}
//               <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                 <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Clinic Details</h2>
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
//                   {[
//                     { label: 'Clinic Name', value: doctor.clinic },
//                     { label: 'Address', value: doctor.location },
//                     { label: 'City', value: doctor.city },
//                     { label: 'Hours', value: doctor.hours },
//                     { label: 'Phone', value: doctor.phone },
//                     { label: 'Website', value: doctor.website, link: true },
//                   ].map(item => (
//                     <div key={item.label}>
//                       <div style={{ fontSize: 11, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 3 }}>{item.label}</div>
//                       {item.link
//                         ? <a href={item.value} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#39a5d3', textDecoration: 'none' }}>{item.value}</a>
//                         : item.label === 'Phone'
//                           ? <a href={`tel:${item.value}`} style={{ fontSize: 13, color: '#19354a', textDecoration: 'none', fontWeight: 600 }}>+91 {item.value}</a>
//                           : <div style={{ fontSize: 13, color: '#333' }}>{item.value}</div>
//                       }
//                     </div>
//                   ))}
//                 </div>
//               </div>

//             </div>
//           )}

//           {/* ── SERVICES TAB ── */}
//           {activeTab === 'services' && (
//             <div style={{ marginTop: 16, background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, paddingBottom: 12, borderBottom: '1px solid #f0f0f0' }}>
//                 <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', margin: 0 }}>Services</h2>
//                 <span style={{ fontSize: 12, color: '#888', background: '#f0f7fb', padding: '3px 10px', borderRadius: 20 }}>{doctor.services.length} services</span>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0' }}>
//                 {doctor.services.map((s, i) => (
//                   <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 8px', borderBottom: i < doctor.services.length - 3 ? '1px solid #f5f5f5' : 'none' }}>
//                     <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0 }} />
//                     <span style={{ fontSize: 13, color: '#444' }}>{s}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* ── STORIES / REVIEWS TAB ── */}
//           {activeTab === 'stories' && (
//             <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 14 }}>

//               {/* Rating Summary */}
//               <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
//                   <div style={{ textAlign: 'center' }}>
//                     <div style={{ fontSize: 48, fontWeight: 800, color: '#19354a', lineHeight: 1 }}>{avgRating}</div>
//                     <StarRating value={Math.round(avgRating)} readonly />
//                     <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{reviews.length} reviews</div>
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     {[5, 4, 3, 2, 1].map(star => {
//                       const count = reviews.filter(r => r.rating === star).length;
//                       const pct = reviews.length ? (count / reviews.length) * 100 : 0;
//                       return (
//                         <div key={star} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
//                           <span style={{ fontSize: 12, color: '#555', width: 12, textAlign: 'right' }}>{star}</span>
//                           <span style={{ fontSize: 12, color: '#39a5d3' }}>★</span>
//                           <div style={{ flex: 1, height: 6, background: '#f0f0f0', borderRadius: 3, overflow: 'hidden' }}>
//                             <div style={{ width: `${pct}%`, height: '100%', background: '#39a5d3', borderRadius: 3 }} />
//                           </div>
//                           <span style={{ fontSize: 12, color: '#888', width: 20 }}>{count}</span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 <button onClick={() => setShowForm(f => !f)}
//                   style={{ marginTop: 18, padding: '10px 24px', background: '#fff', border: '1.5px solid #39a5d3', color: '#39a5d3', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
//                   {showForm ? 'Cancel' : '+ Write a Review'}
//                 </button>
//               </div>

//               {/* Review Form */}
//               {showForm && (
//                 <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
//                   <h3 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 16, marginTop: 0 }}>Share Your Experience</h3>
//                   {submitted ? (
//                     <div style={{ textAlign: 'center', padding: '20px 0' }}>
//                       <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
//                       <p style={{ fontSize: 14, color: '#2e7d32', fontWeight: 600 }}>Thank you for your review!</p>
//                     </div>
//                   ) : (
//                     <form onSubmit={handleSubmitReview}>
//                       <div style={{ marginBottom: 14 }}>
//                         <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Your Name *</label>
//                         <input value={newReview.name} onChange={e => setNewReview(p => ({ ...p, name: e.target.value }))}
//                           placeholder="Enter your name" required
//                           style={{ width: '100%', padding: '10px 14px', border: '1px solid #dde3ea', borderRadius: 8, fontSize: 14, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
//                       </div>
//                       <div style={{ marginBottom: 14 }}>
//                         <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Rating *</label>
//                         <StarRating value={newReview.rating} onChange={v => setNewReview(p => ({ ...p, rating: v }))} />
//                       </div>
//                       <div style={{ marginBottom: 18 }}>
//                         <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Your Review *</label>
//                         <textarea value={newReview.text} onChange={e => setNewReview(p => ({ ...p, text: e.target.value }))}
//                           placeholder="Share details of your experience with Dr. Rustgi..." rows={4} required
//                           style={{ width: '100%', padding: '10px 14px', border: '1px solid #dde3ea', borderRadius: 8, fontSize: 14, outline: 'none', resize: 'none', fontFamily: 'inherit', lineHeight: 1.6, boxSizing: 'border-box' }} />
//                       </div>
//                       <button type="submit"
//                         style={{ padding: '11px 28px', background: '#19354a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
//                         Submit Review
//                       </button>
//                     </form>
//                   )}
//                 </div>
//               )}

//               {/* Review Cards */}
//               {reviews.map(r => (
//                 <div key={r.id} style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//                       <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e8f0fb', color: '#185FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, flexShrink: 0 }}>
//                         {r.name.charAt(0).toUpperCase()}
//                       </div>
//                       <div>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                           <span style={{ fontSize: 14, fontWeight: 600, color: '#19354a' }}>{r.name}</span>
//                           {r.verified && (
//                             <span style={{ fontSize: 11, color: '#2e7d32', fontWeight: 600, background: '#e8f5e9', padding: '1px 6px', borderRadius: 10 }}>Verified</span>
//                           )}
//                         </div>
//                         <div style={{ fontSize: 12, color: '#888', marginTop: 1 }}>
//                           {r.date}{r.visitedFor ? ` · Visited for ${r.visitedFor}` : ''}
//                         </div>
//                       </div>
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                       <StarRating value={r.rating} readonly />
//                       {!r.verified && (
//                         <button
//                           onClick={() => setReviews(prev => prev.filter(x => x.id !== r.id))}
//                           style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 18, lineHeight: 1, padding: 0 }}
//                           title="Delete review">
//                           ×
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                   <p style={{ fontSize: 14, color: '#555', lineHeight: 1.75, margin: 0 }}>{r.text}</p>
//                 </div>
//               ))}
//             </div>
//           )}

//         </div>

//         {/* ── RIGHT SIDEBAR ── */}
//         <div style={{ position: 'sticky', top: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>

//           {/* Slot Booking Card — Practo style */}
//           <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 4, overflow: 'hidden' }}>

//             {/* Header */}
//             <div style={{ padding: '14px 18px', background: '#f8f9fa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <div>
//                 <div style={{ fontSize: 13, fontWeight: 700, color: '#19354a' }}>Clinic Appointment</div>
//                 <div style={{ fontSize: 12, color: '#39a5d3', marginTop: 2 }}>{doctor.clinic}</div>
//               </div>
//               <div style={{ textAlign: 'right' }}>
//                 <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>Consultation Fee</div>
//                 <div style={{ fontSize: 22, fontWeight: 800, color: '#19354a' }}>₹{doctor.fee}</div>
//               </div>
//             </div>

//             {/* Clinic Info */}
//             <div style={{ padding: '10px 18px', borderBottom: '1px solid #f0f0f0', fontSize: 12, color: '#666' }}>
//               <div style={{ marginBottom: 2 }}>{doctor.location}</div>
//               <div style={{ color: '#888' }}>{doctor.hours}</div>
//             </div>

//             {/* Slot Picker */}
//             <SlotPicker doctor={doctor} />

//           </div>

//           {/* Google Maps */}
//           <a href={doctor.googleMaps} target="_blank" rel="noreferrer"
//             style={{ display: 'block', textAlign: 'center', background: '#fff', color: '#19354a', borderRadius: 4, padding: '11px 0', fontSize: 13, fontWeight: 600, textDecoration: 'none', border: '1.5px solid #19354a' }}>
//             Get Directions to Clinic
//           </a>

//           {/* Review button */}
//           <button onClick={() => setActiveTab('stories')}
//             style={{ width: '100%', textAlign: 'center', background: '#fff', color: '#39a5d3', borderRadius: 4, padding: '11px 0', fontSize: 13, fontWeight: 600, border: '1.5px solid #39a5d3', cursor: 'pointer', fontFamily: 'inherit' }}>
//             {reviews.length > 0 ? `Read ${reviews.length} Patient Review${reviews.length > 1 ? 's' : ''}` : 'Write a Review'}
//           </button>

//           {/* No booking fee strip */}
//           <div style={{ background: '#f0f7fb', border: '1px solid #d0e8f5', borderRadius: 4, padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <span style={{ fontSize: 12, color: '#555' }}>No booking fee charged</span>
//             <span style={{ fontSize: 12, fontWeight: 700, color: '#19354a' }}>₹{doctor.fee} only</span>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// };

// export default DrSarojRustgi;


import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const doctor = {
  id: 8,
  name: 'Dr. Saroj Rustgi',
  qual: 'BPTH/BPT, MPTh/MPT, Diploma in Natural Health & Yoga',
  specialty: 'Physiotherapist',
  initials: 'SR',
  color: '#185FA5',
  verified: true,
  image: '/images/doctor1.png',
  clinic: 'Wellness First Physiotherapy+',
  location: 'B-279, Near Hong Kong Bazar, Sushant Lok III, Sector 57, Gurgaon',
  city: 'Gurgaon',
  fee: 1000,
  phone: '7838455530',
  email: 'physio.wellnessfirst@gmail.com',
  website: 'https://wellnessfirstphysio.in',
  googleMaps: 'https://share.google/JP9YIwIlxBrnnpx7i',
  practo: 'https://www.practo.com/gurgaon/doctor/dr-saroj-rustgi-rehab-physical-medicine-specialist',
  hours: 'Mon–Sat: 8:30 AM–2:00 PM & 4:30 PM–7:30 PM | Sun: 9:00 AM–12:30 PM',
  about: 'Dr. Saroj Rustgi (PT) is a renowned physiotherapist with 46 years of experience — 39 years as Head of Physiotherapy Department at Northern Railway Central Hospital, followed by over 10 years running Wellness First Physiotherapy+ in Sushant Lok 3, Sector 57, Gurugram. She specialises in clinical diagnosis, therapeutics, musculoskeletal and sports physiotherapy, and neurological rehabilitation. She also practises advanced techniques including Dry Needling, Cupping, and IASTM. Video consultation is available through her clinic.',
  services: [
    'Exercise Therapy', 'Balance & Coordination Training', 'Gait Training',
    'TENS', 'IFT', 'Muscle Stimulation', 'Short Wave Diathermy', 'LASER Therapy',
    'Manual Therapy', 'Trigger Point Therapy', 'Joint Mobilization', 'Myofascial Release',
    'Stroke Rehabilitation', 'Knee Replacement Rehab', 'Hip Replacement Rehab',
    'Back Pain Treatment', 'Neck Pain Treatment', 'Home Physiotherapy Services',
    'Dry Needling', 'Cupping Therapy', 'IASTM', 'Cryotherapy / Cold Therapy',
    'Heat Therapy', 'Electrical Stimulation',
  ],
  specializations: [
    'Sports & Musculoskeletal Physiotherapist',
    'Orthopaedic Physiotherapist',
    'Neurological Rehabilitation',
    'Cardiovascular & Pulmonary Physiotherapy',
  ],
  education: [
    { degree: 'BPTH/BPT', institute: 'Pt. Deen Dayal Upadhyaya Institute for the Physically Handicapped, New Delhi', year: '1975' },
    { degree: 'MPTh/MPT — Orthopaedic Physiotherapy', institute: 'Singhania University, Jhunjhunu', year: '2010' },
    { degree: 'Diploma in Natural Health & Yoga', institute: 'International Foundation of Natural Health and Yoga', year: '1992' },
  ],
  memberships: ['Indian Association of Physiotherapists'],
  awards: [
    'Guest of Honour — ITS College of Physiotherapy, Meerut',
    'Certificate of Merit — Northern Railway',
    'Head of Physiotherapy Department — Northern Railway Central Hospital (39 years)',
  ],
};

const StarRating = ({ value, onChange, readonly = false }) => (
  <div style={{ display: 'flex', gap: 4 }}>
    {[1, 2, 3, 4, 5].map(star => (
      <button key={star} onClick={() => !readonly && onChange(star)}
        style={{ background: 'none', border: 'none', cursor: readonly ? 'default' : 'pointer', padding: 0, fontSize: 22, color: star <= value ? '#39a5d3' : '#d1d5db', lineHeight: 1 }}>
        ★
      </button>
    ))}
  </div>
);

const morningSlots = ['8:30 AM','9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM'];
const afternoonSlots = ['12:00 PM','12:30 PM','1:00 PM','1:30 PM'];
const eveningSlots = ['4:30 PM','5:00 PM','5:30 PM','6:00 PM','6:30 PM','7:00 PM','7:30 PM'];
const sundaySlots  = ['9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','12:30 PM'];

const SlotPicker = ({ doctor }) => {
  const [selected, setSelected] = useState(null);

  const SlotBtn = ({ time }) => (
    <button onClick={() => setSelected(time)}
      style={{
        padding: '6px 0', fontSize: 12, borderRadius: 3, cursor: 'pointer',
        border: selected === time ? '1.5px solid #39a5d3' : '1px solid #d0e0ea',
        background: selected === time ? '#e8f4fb' : '#fff',
        color: selected === time ? '#39a5d3' : '#444',
        fontWeight: selected === time ? 700 : 400,
        fontFamily: 'inherit', transition: 'all 0.1s',
        width: '31%',
      }}>
      {time}
    </button>
  );

  const allMonSatSlots = [...morningSlots, ...afternoonSlots, ...eveningSlots];

  const handleBook = () => {
    const params = new URLSearchParams({
      doctor: doctor.name,
      clinic: doctor.clinic,
      slot: selected,
      phone: doctor.phone,
    });
    window.location.href = `/book-appointment?${params.toString()}`;
  };

  return (
    <div style={{ padding: '14px 18px' }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#19354a', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Mon – Sat</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
        {allMonSatSlots.map(t => <SlotBtn key={t} time={t} />)}
      </div>
      <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 12, marginBottom: 8 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#19354a', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Sunday</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
          {sundaySlots.map(t => <SlotBtn key={t} time={t} />)}
        </div>
      </div>
      {selected && (
        <div style={{ padding: '8px 12px', background: '#f0f7fb', borderRadius: 3, fontSize: 12, color: '#19354a', marginBottom: 10 }}>
          Selected: <strong>{selected}</strong>
        </div>
      )}
      <button onClick={handleBook} disabled={!selected}
        style={{
          width: '100%', padding: '11px 0', fontSize: 13, fontWeight: 700,
          background: selected ? '#39a5d3' : '#e8e8e8',
          color: selected ? '#fff' : '#aaa',
          border: 'none', borderRadius: 3,
          cursor: selected ? 'pointer' : 'not-allowed',
          fontFamily: 'inherit',
        }}>
        {selected ? 'Book Appointment' : 'Select a Time Slot'}
      </button>
    </div>
  );
};

const DrSarojRustgi = () => {
  const [activeTab, setActiveTab] = useState('info');
  const [reviews, setReviews] = useState([
    {
      id: 1,
      name: 'Nitin Saraswat',
      verified: true,
      visitedFor: 'Neurological Rehabilitation',
      rating: 5,
      date: '10 years ago',
      text: 'We were actively looking out for a good physiotherapist for my father who suffered a stroke 3 years back. We tried services like Portea and found that their physios did not have an empathetic attitude towards the patient. Ms. Saroj and Mr. Ishwar have done a great job in striking a bonding with my father and providing a more holistic and empathetic physio treatment. Their services are both economical and effective and its been more than 4 months and I am a regular visitor there.',
    },
    {
      id: 2,
      name: 'Anusha Bode',
      verified: true,
      visitedFor: 'Back Pain',
      rating: 5,
      date: '2 years ago',
      text: 'It was a great experience with Dr. Saroj Ji. My husband went to consult about my lower back pain which was an ongoing issue from last few years. We consulted other physiotherapists in the past and they simply treated it with wave therapy. What really sets Dr. Saroj apart is the explanation behind what is done. She explained why lower back pain happens, the causes in detail, and helped me realise that bad posture is the biggest culprit. With every session, she suggested how to include good posture habits in our daily routine and some light exercises to strengthen the core. I liked that she treated the issue not just professionally but gave personal tips for long term recovery. I would strongly recommend her.',
    },
    {
      id: 3,
      name: 'Manoj Kumar',
      verified: true,
      visitedFor: 'Shoulder Pain',
      rating: 5,
      date: '3 years ago',
      text: 'I had pain in my shoulder since last three months. I consulted Dr. Saroj for this and she prescribed physiotherapy sessions at her clinic for 10 days. I underwent these sessions and also did multiple physical exercises advised by the doctor on daily basis. The doctor closely watched me performing the exercises and corrected me where required. After 10 sessions I have fully recovered from my pain. I strongly recommend Dr. Saroj for her expertise and thorough knowledge.',
    },
  ]);
  const [showForm, setShowForm] = useState(false);
  const [newReview, setNewReview] = useState({ name: '', rating: 0, text: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmitReview = (e) => {
    e.preventDefault();
    if (!newReview.name || !newReview.rating || !newReview.text) return;
    setReviews(prev => [{
      id: Date.now(),
      name: newReview.name,
      rating: newReview.rating,
      date: 'Just now',
      text: newReview.text,
    }, ...prev]);
    setNewReview({ name: '', rating: 0, text: '' });
    setSubmitted(true);
    setTimeout(() => { setSubmitted(false); setShowForm(false); }, 2000);
  };

  const avgRating = reviews.length
    ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1)
    : null;

  const tabs = ['info', 'services', 'stories'];

  return (
    <div style={{ minHeight: '100vh', background: '#f7f8fa', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Breadcrumb */}
      <div style={{ background: '#fff', borderBottom: '1px solid #eaecef', padding: '10px 0' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 16px', fontSize: 12, color: '#888', display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <Link to="/" style={{ color: '#888', textDecoration: 'none' }}>Home</Link>
          <span>›</span>
          <Link to="/doctors" style={{ color: '#888', textDecoration: 'none' }}>Find Doctors</Link>
          <span>›</span>
          <Link to="/doctors?city=Gurgaon" style={{ color: '#888', textDecoration: 'none' }}>Gurgaon</Link>
          <span>›</span>
          <Link to="/doctors?specialty=Physiotherapist" style={{ color: '#888', textDecoration: 'none' }}>Physiotherapist</Link>
          <span>›</span>
          <span style={{ color: '#333' }}>Dr. Saroj Rustgi</span>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '16px auto', padding: '0 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, alignItems: 'start' }}>

        {/* ── LEFT ── */}
        <div>

          {/* Doctor Header Card */}
          <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: '28px 28px 0', marginBottom: 0 }}>
            <div style={{ display: 'flex', gap: 16, paddingBottom: 20, borderBottom: '1px solid #eaecef', flexWrap: 'wrap' }}>
              <div style={{ width: 88, height: 88, borderRadius: 4, overflow: 'hidden', flexShrink: 0, border: '1px solid #eaecef' }}>
                <img src={doctor.image} alt={doctor.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  onError={e => {
                    e.target.style.display = 'none';
                    e.target.parentNode.style.background = '#e8f0fb';
                    e.target.parentNode.style.display = 'flex';
                    e.target.parentNode.style.alignItems = 'center';
                    e.target.parentNode.style.justifyContent = 'center';
                    e.target.parentNode.innerHTML = `<span style="font-size:26px;font-weight:700;color:#185FA5">${doctor.initials}</span>`;
                  }}
                />
              </div>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 3 }}>
                  <h1 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', margin: 0 }}>{doctor.name}</h1>
                  {doctor.verified && (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#2e7d32', fontWeight: 600 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                      Medical Registration Verified
                    </span>
                  )}
                </div>
                <p style={{ fontSize: 14, color: '#555', margin: '0 0 3px' }}>{doctor.qual}</p>
                <p style={{ fontSize: 14, color: '#39a5d3', fontWeight: 600, margin: '0 0 6px' }}>{doctor.specialty}</p>
                <p style={{ fontSize: 13, color: '#666', margin: '0 0 10px' }}>40+ Years Experience Overall</p>
                {avgRating && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#39a5d3', color: '#fff', fontSize: 13, fontWeight: 700, padding: '3px 10px', borderRadius: 6 }}>
                      ★ {avgRating}
                    </div>
                    <span style={{ fontSize: 13, color: '#555' }}>{reviews.length} Patient Reviews</span>
                    <button onClick={() => setActiveTab('stories')}
                      style={{ fontSize: 12, color: '#39a5d3', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0 }}>
                      See all reviews
                    </button>
                  </div>
                )}
                {!avgRating && (
                  <button onClick={() => setActiveTab('stories')}
                    style={{ fontSize: 13, color: '#39a5d3', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontFamily: 'inherit' }}>
                    Be the first to write a review
                  </button>
                )}
              </div>
            </div>

            {/* Tabs */}
            <div style={{ display: 'flex', gap: 0, overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              {tabs.map(tab => (
                <button key={tab} onClick={() => setActiveTab(tab)}
                  style={{
                    padding: '14px 24px', fontSize: 14, fontWeight: activeTab === tab ? 700 : 400,
                    color: activeTab === tab ? '#39a5d3' : '#888',
                    background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit',
                    borderBottom: activeTab === tab ? '2.5px solid #39a5d3' : '2.5px solid transparent',
                    transition: 'all 0.15s', textTransform: 'capitalize', whiteSpace: 'nowrap',
                  }}>
                  {tab === 'stories' ? `Stories (${reviews.length})` : tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </div>

          {/* ── INFO TAB ── */}
          {activeTab === 'info' && (
            <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 12, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>About</h2>
                <p style={{ fontSize: 14, color: '#555', lineHeight: 1.75, margin: 0 }}>{doctor.about}</p>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                  <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Specializations</h2>
                  {doctor.specializations.map(s => (
                    <div key={s} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', marginBottom: 10 }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 5 }} />{s}
                    </div>
                  ))}
                </div>
                <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                  <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Education</h2>
                  {doctor.education.map((e, i) => (
                    <div key={i} style={{ marginBottom: 12 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{e.degree}</div>
                      {e.institute && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{e.institute}{e.year ? `, ${e.year}` : ''}</div>}
                      {e.note && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{e.note}</div>}
                    </div>
                  ))}
                </div>
              </div>
              {doctor.awards.length > 0 && (
                <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                  <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Awards & Recognition</h2>
                  {doctor.awards.map(a => (
                    <div key={a} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, color: '#444', marginBottom: 8 }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 5, display: 'inline-block' }} />{a}
                    </div>
                  ))}
                </div>
              )}
              <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>Clinic Details</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
                  {[
                    { label: 'Clinic Name', value: doctor.clinic },
                    { label: 'Address', value: doctor.location },
                    { label: 'City', value: doctor.city },
                    { label: 'Hours', value: doctor.hours },
                    { label: 'Phone', value: doctor.phone },
                    { label: 'Website', value: doctor.website, link: true },
                  ].map(item => (
                    <div key={item.label}>
                      <div style={{ fontSize: 11, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 3 }}>{item.label}</div>
                      {item.link
                        ? <a href={item.value} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#39a5d3', textDecoration: 'none' }}>{item.value}</a>
                        : item.label === 'Phone'
                          ? <a href={`tel:${item.value}`} style={{ fontSize: 13, color: '#19354a', textDecoration: 'none', fontWeight: 600 }}>+91 {item.value}</a>
                          : <div style={{ fontSize: 13, color: '#333' }}>{item.value}</div>
                      }
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ── SERVICES TAB ── */}
          {activeTab === 'services' && (
            <div style={{ marginTop: 16, background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, paddingBottom: 12, borderBottom: '1px solid #f0f0f0' }}>
                <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', margin: 0 }}>Services</h2>
                <span style={{ fontSize: 12, color: '#888', background: '#f0f7fb', padding: '3px 10px', borderRadius: 20 }}>{doctor.services.length} services</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 0 }}>
                {doctor.services.map((s, i) => (
                  <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 8px', borderBottom: i < doctor.services.length - 3 ? '1px solid #f5f5f5' : 'none' }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#39a5d3', flexShrink: 0 }} />
                    <span style={{ fontSize: 13, color: '#444' }}>{s}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ── STORIES / REVIEWS TAB ── */}
          {activeTab === 'stories' && (
            <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 48, fontWeight: 800, color: '#19354a', lineHeight: 1 }}>{avgRating}</div>
                    <StarRating value={Math.round(avgRating)} readonly />
                    <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{reviews.length} reviews</div>
                  </div>
                  <div style={{ flex: 1, minWidth: 200 }}>
                    {[5, 4, 3, 2, 1].map(star => {
                      const count = reviews.filter(r => r.rating === star).length;
                      const pct = reviews.length ? (count / reviews.length) * 100 : 0;
                      return (
                        <div key={star} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                          <span style={{ fontSize: 12, color: '#555', width: 12, textAlign: 'right' }}>{star}</span>
                          <span style={{ fontSize: 12, color: '#39a5d3' }}>★</span>
                          <div style={{ flex: 1, height: 6, background: '#f0f0f0', borderRadius: 3, overflow: 'hidden' }}>
                            <div style={{ width: `${pct}%`, height: '100%', background: '#39a5d3', borderRadius: 3 }} />
                          </div>
                          <span style={{ fontSize: 12, color: '#888', width: 20 }}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <button onClick={() => setShowForm(f => !f)}
                  style={{ marginTop: 18, padding: '10px 24px', background: '#fff', border: '1.5px solid #39a5d3', color: '#39a5d3', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                  {showForm ? 'Cancel' : '+ Write a Review'}
                </button>
              </div>
              {showForm && (
                <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 24 }}>
                  <h3 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 16, marginTop: 0 }}>Share Your Experience</h3>
                  {submitted ? (
                    <div style={{ textAlign: 'center', padding: '20px 0' }}>
                      <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
                      <p style={{ fontSize: 14, color: '#2e7d32', fontWeight: 600 }}>Thank you for your review!</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmitReview}>
                      <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Your Name *</label>
                        <input value={newReview.name} onChange={e => setNewReview(p => ({ ...p, name: e.target.value }))}
                          placeholder="Enter your name" required
                          style={{ width: '100%', padding: '10px 14px', border: '1px solid #dde3ea', borderRadius: 8, fontSize: 14, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Rating *</label>
                        <StarRating value={newReview.rating} onChange={v => setNewReview(p => ({ ...p, rating: v }))} />
                      </div>
                      <div style={{ marginBottom: 18 }}>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Your Review *</label>
                        <textarea value={newReview.text} onChange={e => setNewReview(p => ({ ...p, text: e.target.value }))}
                          placeholder="Share details of your experience with Dr. Rustgi..." rows={4} required
                          style={{ width: '100%', padding: '10px 14px', border: '1px solid #dde3ea', borderRadius: 8, fontSize: 14, outline: 'none', resize: 'none', fontFamily: 'inherit', lineHeight: 1.6, boxSizing: 'border-box' }} />
                      </div>
                      <button type="submit"
                        style={{ padding: '11px 28px', background: '#19354a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                        Submit Review
                      </button>
                    </form>
                  )}
                </div>
              )}
              {reviews.map(r => (
                <div key={r.id} style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e8f0fb', color: '#185FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, flexShrink: 0 }}>
                        {r.name.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ fontSize: 14, fontWeight: 600, color: '#19354a' }}>{r.name}</span>
                          {r.verified && (
                            <span style={{ fontSize: 11, color: '#2e7d32', fontWeight: 600, background: '#e8f5e9', padding: '1px 6px', borderRadius: 10 }}>Verified</span>
                          )}
                        </div>
                        <div style={{ fontSize: 12, color: '#888', marginTop: 1 }}>
                          {r.date}{r.visitedFor ? ` · Visited for ${r.visitedFor}` : ''}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <StarRating value={r.rating} readonly />
                      {!r.verified && (
                        <button
                          onClick={() => setReviews(prev => prev.filter(x => x.id !== r.id))}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 18, lineHeight: 1, padding: 0 }}
                          title="Delete review">
                          ×
                        </button>
                      )}
                    </div>
                  </div>
                  <p style={{ fontSize: 14, color: '#555', lineHeight: 1.75, margin: 0 }}>{r.text}</p>
                </div>
              ))}
            </div>
          )}

        </div>

        {/* ── RIGHT SIDEBAR ── */}
        <div style={{ position: 'sticky', top: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', background: '#f8f9fa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#19354a' }}>Clinic Appointment</div>
                <div style={{ fontSize: 12, color: '#39a5d3', marginTop: 2 }}>{doctor.clinic}</div>
              </div>
            </div>
            <div style={{ padding: '10px 18px', borderBottom: '1px solid #f0f0f0', fontSize: 12, color: '#666' }}>
              <div style={{ marginBottom: 2 }}>{doctor.location}</div>
              <div style={{ color: '#888' }}>{doctor.hours}</div>
            </div>
            <SlotPicker doctor={doctor} />
          </div>
          <a href={doctor.googleMaps} target="_blank" rel="noreferrer"
            style={{ display: 'block', textAlign: 'center', background: '#fff', color: '#19354a', borderRadius: 4, padding: '11px 0', fontSize: 13, fontWeight: 600, textDecoration: 'none', border: '1.5px solid #19354a' }}>
            Get Directions to Clinic
          </a>
          <button onClick={() => setActiveTab('stories')}
            style={{ width: '100%', textAlign: 'center', background: '#fff', color: '#39a5d3', borderRadius: 4, padding: '11px 0', fontSize: 13, fontWeight: 600, border: '1.5px solid #39a5d3', cursor: 'pointer', fontFamily: 'inherit' }}>
            {reviews.length > 0 ? `Read ${reviews.length} Patient Review${reviews.length > 1 ? 's' : ''}` : 'Write a Review'}
          </button>
          </div>

      </div>
    </div>
  );
};

export default DrSarojRustgi;